/* tslint:disable */
/* eslint-disable */
/**
 * HashiCorp Cloud Platform Infragraph Service
 * APIs for managing Infragraph.
 *
 * The version of the OpenAPI document: 2025-05-07
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { HashicorpCloudInfragraph20250507ListConnectionResponseFromJSON, HashicorpCloudInfragraph20250507ReadConnectionResponseFromJSON, HashicorpCloudInfragraph20250507UpsertConnectionBodyToJSON, HashicorpCloudInfragraph20250507UpsertConnectionResponseFromJSON, } from '../models/index';
/**
 *
 */
export class ConnectionServiceApi extends runtime.BaseAPI {
    /**
     * Delete removes a connection (soft delete).
     */
    async connectionServiceDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters['locationOrganizationId'] == null) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter "locationOrganizationId" was null or undefined when calling connectionServiceDelete().');
        }
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling connectionServiceDelete().');
        }
        const queryParameters = {};
        if (requestParameters['locationProjectId'] != null) {
            queryParameters['location.project_id'] = requestParameters['locationProjectId'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/infragraph/2025-05-07/organizations/{location.organization_id}/connections/{id}`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters['locationOrganizationId']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Delete removes a connection (soft delete).
     */
    async connectionServiceDelete(locationOrganizationId, id, locationProjectId, initOverrides) {
        const response = await this.connectionServiceDeleteRaw({ locationOrganizationId: locationOrganizationId, id: id, locationProjectId: locationProjectId }, initOverrides);
        return await response.value();
    }
    /**
     * List returns all connections for an organization, optionally filtered by type.
     */
    async connectionServiceListRaw(requestParameters, initOverrides) {
        if (requestParameters['locationOrganizationId'] == null) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter "locationOrganizationId" was null or undefined when calling connectionServiceList().');
        }
        const queryParameters = {};
        if (requestParameters['locationProjectId'] != null) {
            queryParameters['location.project_id'] = requestParameters['locationProjectId'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/infragraph/2025-05-07/organizations/{location.organization_id}/connections`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters['locationOrganizationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudInfragraph20250507ListConnectionResponseFromJSON(jsonValue));
    }
    /**
     * List returns all connections for an organization, optionally filtered by type.
     */
    async connectionServiceList(locationOrganizationId, locationProjectId, initOverrides) {
        const response = await this.connectionServiceListRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId }, initOverrides);
        return await response.value();
    }
    /**
     * Read retrieves a single connection by its identifier.
     */
    async connectionServiceReadRaw(requestParameters, initOverrides) {
        if (requestParameters['locationOrganizationId'] == null) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter "locationOrganizationId" was null or undefined when calling connectionServiceRead().');
        }
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling connectionServiceRead().');
        }
        const queryParameters = {};
        if (requestParameters['locationProjectId'] != null) {
            queryParameters['location.project_id'] = requestParameters['locationProjectId'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/infragraph/2025-05-07/organizations/{location.organization_id}/connections/{id}`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters['locationOrganizationId']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudInfragraph20250507ReadConnectionResponseFromJSON(jsonValue));
    }
    /**
     * Read retrieves a single connection by its identifier.
     */
    async connectionServiceRead(locationOrganizationId, id, locationProjectId, initOverrides) {
        const response = await this.connectionServiceReadRaw({ locationOrganizationId: locationOrganizationId, id: id, locationProjectId: locationProjectId }, initOverrides);
        return await response.value();
    }
    /**
     * Upsert creates or updates a connection. When ID is provided, updates the existing connection.
     */
    async connectionServiceUpsertRaw(requestParameters, initOverrides) {
        if (requestParameters['locationOrganizationId'] == null) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter "locationOrganizationId" was null or undefined when calling connectionServiceUpsert().');
        }
        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError('body', 'Required parameter "body" was null or undefined when calling connectionServiceUpsert().');
        }
        const queryParameters = {};
        if (requestParameters['locationProjectId'] != null) {
            queryParameters['location.project_id'] = requestParameters['locationProjectId'];
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/infragraph/2025-05-07/organizations/{location.organization_id}/connections`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters['locationOrganizationId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudInfragraph20250507UpsertConnectionBodyToJSON(requestParameters['body']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudInfragraph20250507UpsertConnectionResponseFromJSON(jsonValue));
    }
    /**
     * Upsert creates or updates a connection. When ID is provided, updates the existing connection.
     */
    async connectionServiceUpsert(locationOrganizationId, body, locationProjectId, initOverrides) {
        const response = await this.connectionServiceUpsertRaw({ locationOrganizationId: locationOrganizationId, body: body, locationProjectId: locationProjectId }, initOverrides);
        return await response.value();
    }
}
